'use client';

import { useRouter } from 'next/navigation';
import React, { useCallback, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import RichText from '@/components/RichText';
import { Button } from '@/components/ui/button';
import { Turnstile } from 'next-turnstile';
import { buildInitialFormState } from './buildInitialFormState';
import { fields } from './fields';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
export const FormBlock = props => {
  const {
    enableIntro,
    form: formFromProps,
    form: {
      id: formID,
      confirmationMessage,
      confirmationType,
      redirect,
      submitButtonLabel
    } = {},
    introContent
  } = props;
  const formMethods = useForm({
    defaultValues: buildInitialFormState(formFromProps.fields)
  });
  const {
    control,
    formState: {
      errors
    },
    handleSubmit,
    register
  } = formMethods;
  const [isLoading, setIsLoading] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState();
  const [error, setError] = useState();
  const [turnstileToken, setTurnstileToken] = useState();
  const router = useRouter();
  const t = useTranslations();
  const onSubmit = useCallback(data => {
    let loadingTimerID;
    const submitForm = async () => {
      setError(undefined);
      const dataToSend = Object.entries(data).map(([name, value]) => ({
        field: name,
        value
      }));

      // delay loading indicator by 1s
      loadingTimerID = setTimeout(() => {
        setIsLoading(true);
      }, 1000);
      try {
        const req = await fetch(`/api/form-submissions`, {
          body: JSON.stringify({
            form: formID,
            submissionData: dataToSend,
            turnstileToken
          }),
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST'
        });
        const res = await req.json();
        clearTimeout(loadingTimerID);
        if (req.status >= 400) {
          setIsLoading(false);
          setError({
            message: res.errors?.[0]?.message || 'Internal Server Error',
            status: res.status
          });
          return;
        }
        setIsLoading(false);
        setHasSubmitted(true);
        setTurnstileToken(undefined);
        if (confirmationType === 'redirect' && redirect) {
          const {
            url
          } = redirect;
          const redirectUrl = url;
          if (redirectUrl) router.push(redirectUrl);
        }
      } catch (err) {
        console.warn(err);
        setIsLoading(false);
        setError({
          message: 'Something went wrong.'
        });
      }
    };
    void submitForm();
  }, [router, formID, redirect, confirmationType, turnstileToken]);
  return <div className="md:flex">
      <div className="container lg:max-w-[48rem] py-20 ">
        <FormProvider {...formMethods}>
          {enableIntro && introContent && !hasSubmitted &&
        // @ts-ignore
        <RichText className="mb-8" data={introContent} enableGutter={false} />}
          {!isLoading && hasSubmitted && confirmationType === 'message' && <RichText data={confirmationMessage} />}
          {isLoading && !hasSubmitted && <p>{t('loading')}</p>}
          {error && <div>{`${error.status || '500'}: ${error.message || ''}`}</div>}
          {!hasSubmitted && <form id={formID} onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-4 last:mb-0">
                {formFromProps && formFromProps.fields && formFromProps.fields?.map((field, index) => {
              const Field = fields?.[field.blockType];
              if (Field) {
                return <div className="mb-6 last:mb-0" key={index}>
                          <Field form={formFromProps} {...field} {...formMethods} control={control} errors={errors} register={register} />
                        </div>;
              }
              return null;
            })}
              </div>

              {process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY && <div className="mb-6">
                  <Turnstile siteKey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY} onVerify={token => setTurnstileToken(token)} onExpire={() => setTurnstileToken(undefined)} onError={() => setTurnstileToken(undefined)} theme="auto" />
                </div>}

              <Button form={formID} type="submit" variant="default" disabled={!turnstileToken}>
                {submitButtonLabel}
              </Button>
            </form>}
        </FormProvider>
      </div>
      <div className="w-full md:w-1/2 h-screen relative ">
    <div className="absolute inset-0">
    <Image src="/assets/1.webp" alt="Description of image" className=" w-auto h-full object-cover opacity-50" fill objectPosition="center top" objectFit="cover" />
      </div>  
      
      </div>
    </div>;
};